import clsx from 'clsx';
import { LoadingSpinner, Stack } from 'components';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getMedicalVisitsPreview } from 'store/medicalVisits/medicalVisitsActions';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { ReactComponent as MoreIcon } from 'assets/svg/more_icon.svg';

import style from './medicalVisits.module.scss';
import MedicalVisitsModal from './medicalVisitsModal';

const MedicalVisits = () => {
  const { clientId } = useParams();
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const [showSection, setShowSection] = useState(true);
  const { medicalVisitsPreviewList, medicalVisitsPreviewListLoading } = useAppSelector(
    (state) => state.medicalVisits
  );
  const { enableFileUpload } = useFlags();

  const text = enableFileUpload ? 'Medical Visits' : 'Clinical Encounters';

  useEffect(() => {
    if (clientId) {
      dispatch(
        getMedicalVisitsPreview({
          clientId
        })
      );
    }
  }, []);

  const handleModalOpen = () => setOpen(true);
  const handleToggleSection = () => setShowSection(!showSection);

  return (
    <Stack width="100%" mb="16px" data-test-id="medical-visits">
      <Stack className={style.wrapper} flexDirection="row">
        <p className={style.title}>{text}</p>
        <div>
          <span onClick={handleModalOpen} className={clsx('material-icons-outlined', style.icon)}>
            open_in_new
          </span>
          {enableFileUpload && (
            <span
              onClick={handleToggleSection}
              className={clsx('material-icons-outlined', style.icon)}
            >
              {showSection ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
            </span>
          )}
        </div>
      </Stack>
      {open && <MedicalVisitsModal open={open} setOpen={setOpen} />}
      {enableFileUpload && !showSection ? null : medicalVisitsPreviewListLoading ? (
        <Stack width="100%" height="100%" justifyContent="center" alignItems="center" mt="16px">
          <LoadingSpinner />
        </Stack>
      ) : medicalVisitsPreviewList?.length > 0 ? (
        <Stack gap="8px" mx="12px" mt="12px">
          {medicalVisitsPreviewList
            .map((item, index) =>
              index >= 3 ? (
                enableFileUpload ? (
                  <span key={item.id}>
                    <MoreIcon />
                  </span>
                ) : null
              ) : (
                <Stack
                  flexDirection="row"
                  justifyContent="space-between"
                  fontSize="12px"
                  lineHeight="140%"
                  key={item.id}
                  onClick={handleModalOpen}
                  sx={{ cursor: 'pointer' }}
                >
                  <div className={style.locationText}>{item.location || '-'}</div>
                  <div style={{ fontVariantNumeric: 'tabular-nums' }}>
                    {item.dateOfEncounter ? dayjs(item.dateOfEncounter).format('M/DD/YY') : '-'}
                  </div>
                </Stack>
              )
            )
            .slice(0, 4)}
        </Stack>
      ) : (
        <Stack ml="16px" mt="12px" fontSize="12px">
          No encounters
        </Stack>
      )}
    </Stack>
  );
};

export default MedicalVisits;
